import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { faChartPie, faWater } from "@fortawesome/free-solid-svg-icons";
import { useQuery } from "@apollo/client";

import HeaderBox from "../reuseableComponents/headerBox/HeaderBox";
import { GET_APP_MENU } from "../../queries/menuQrys/baseWLMenuQrys";
import SkeletonLoader from "../reuseableComponents/loaders/SkeletonLoader";
import ErrorMessage from "../reuseableComponents/ErrorHandler";
import MenuCard from "../reuseableComponents/MenuCard";

const menuIcons = {
  WSSR: faChartPie,
  EPA_HEALTH: faWater
};

const StateWideReportsIndex = () => {
  const { loading, data, error } = useQuery(GET_APP_MENU, { variables: { menu: "SWR" } });
  if (loading || error) {
    return (
      <div className='page-container statewide-reports-index-container'>
        <Row>
          <Col>
            <Link className='m-2 hyperlink' to='/' cypressid='home-page'>
              Home
            </Link>
          </Col>
        </Row>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='swr-page'>
              <h3 style={{ color: "#fff" }}>Statewide Reports</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>{loading ? <SkeletonLoader width='100%' /> : error ? <ErrorMessage error={error} /> : ""}</Col>
        </Row>
      </div>
    );
  }
  return (
    <div className='page-container statewide-reports-index-container'>
      <Row>
        <Col>
          <Link className='m-2 hyperlink' to='/'>
            Home
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='swr-page'>
            <h3 style={{ color: "#fff" }}>Statewide Reports</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        {data.getAppMenu.map((module) => (
          <Col md={4} key={module.value}>
            <MenuCard icon={menuIcons[module.value]} module={module.value} route={module.route} name={module.label} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default StateWideReportsIndex;
